var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav"},[_c('div',{on:{"click":_vm.goback}},[_c('img',{staticClass:"back",attrs:{"src":require("../assets/icon/back.png"),"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }